import api from '../api';
import {VersionedAPIPath} from "@/api/api";

export default {
    //Get Active Clients
    async getVersionInfo(){
        let url = VersionedAPIPath + '/info/web-app/version';
        return api.get(url, { timeout: 10000} );
    }
}